import { useSelector } from 'react-redux';
import { selectors } from '../store';
import { useEffect, useState } from 'react';
import { validateDeal } from '../utils/validators';

export const useValidate = () => {
    const selectedDealer = useSelector(selectors.getSelectedDealer);
    const selectedVehicle = useSelector(selectors.getSelectedVehicle);
    const isConsumerValid = useSelector(selectors.getConsumerValidState);
    const [isDealValid, setIsDealValid] = useState(false);
    const [isVehicleValid, setIsVehicleValid] = useState(true);

    // Validation Logic for the changes on Open Deal Activity
    useEffect(() => {
        const { isDealValid, isVehicleValid } = validateDeal(selectedVehicle, isConsumerValid, selectedDealer);
        setIsDealValid(isDealValid);
        setIsVehicleValid(isVehicleValid);
    }, [selectedDealer?.dealerId, selectedVehicle, isConsumerValid]);

    return {
        isVehicleValid,
        isDealValid
    };
};
